import { useCallback } from 'react';
import { InstallModal, useAutoOpenInstall } from './InstallModal.js';
import { useInstallModal } from './installModalStore.js';

/**
 * Mounts the install modal at the app root, wires the global store, and
 * watches the URL for `?install=1` (deep-link from the landing site's
 * Android install button). The actual modal is in `InstallModal.tsx`.
 */
export function InstallController() {
  const open = useInstallModal((s) => s.open);
  const setOpen = useInstallModal((s) => s.setOpen);
  useAutoOpenInstall(setOpen);
  const onClose = useCallback(() => setOpen(false), [setOpen]);
  return <InstallModal open={open} onClose={onClose} />;
}
